import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "children", "required", "error", "classes"];
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { createUseStyles } from 'react-jss';
import withMemo from '../../../decorators/withMemo';
import { mergeStyles } from '../../../utils/StyleUtils';
import styles from './styles';
var useStyles = createUseStyles(styles);
function FormLabel(props) {
  var className = props.className,
    children = props.children,
    required = props.required,
    error = props.error,
    classesProp = props.classes,
    others = _objectWithoutProperties(props, _excluded);
  var classesComp = useStyles(props);
  var classes = useMemo(function () {
    return mergeStyles(classesComp, classesProp);
  }, [classesProp, classesComp]);
  if (!children) {
    return null;
  }
  return /*#__PURE__*/React.createElement("span", _extends({}, others, {
    className: cx(classes.container, className)
  }), children);
}
FormLabel.styles = styles;
FormLabel.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string),
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
  children: PropTypes.node,
  required: PropTypes.bool,
  error: PropTypes.bool
};
FormLabel.defaultProps = {
  classes: {},
  className: null,
  children: '',
  required: false,
  error: false
};
export default withMemo()(FormLabel);